import { Container } from 'inversify'
import { ErrorPlatformEvent, interpret } from 'xstate'
import { rootContainer } from '~/container'
import sentryCapture from '~/utility/sentryCapture'
import { AjaxCampsiteDetailsRepository } from './AjaxCampsiteDetailsRepository'
import { CampsiteChargeTypesRepositoryFetch } from './CampsiteChargeTypesRepositoryFetch'
import {
  CampsiteChargeTypesRepository,
  CampsiteDetailsRepository,
} from './repositories'
import { ChargeTypesInput } from './types'
import { returnChargeTypesStateMachine } from './machines'

export const campsiteDetailsContainer = new Container()
campsiteDetailsContainer.parent = rootContainer

campsiteDetailsContainer
  .bind(CampsiteDetailsRepository)
  .to(AjaxCampsiteDetailsRepository)

campsiteDetailsContainer
  .bind(CampsiteChargeTypesRepository)
  .to(CampsiteChargeTypesRepositoryFetch)

export function getChargeTypesStateMachine(langCode: string) {
  return interpret(
    returnChargeTypesStateMachine().withConfig({
      services: {
        searchService: async ({
          params,
        }: {
          params: ChargeTypesInput | null
        }) => {
          if (!params) {
            throw new Error('no params')
          }
          const response = await campsiteDetailsContainer
            .get(CampsiteChargeTypesRepository)
            .get(params, langCode)
          return response.map((ct) => Object.freeze(ct))
        },
      },
      actions: {
        logError: (_, _event: any) => {
          const event: ErrorPlatformEvent = _event
          event.data.name = 'chargeTypesStateMachine ' + event.type + ' error'
          sentryCapture(event.data, rootContainer)
        },
      },
    }),
  )
}
